import { NotificationSwitcher } from '@core/model/framework/notifications/notificationSwitcher';
import {
  WaitOnCaseStateNotificationGateway,
  WaitOnCaseStateNotificationGatewayInput,
  WaitOnCaseStateNotificationGatewayOutput,
} from '@core/model/gateway/waitOnCaseStateNotificationGateway';
import { inject, injectable } from 'inversify';

@injectable()
export class WaitOnCaseStateNotificationSwitcher implements WaitOnCaseStateNotificationGateway {
  constructor(@inject(NotificationSwitcher) private notificationSwitcher: NotificationSwitcher) {}

  async awaitCaseStateUpdate(
    input: WaitOnCaseStateNotificationGatewayInput
  ): WaitOnCaseStateNotificationGatewayOutput {
    return await this.notificationSwitcher
      .getWaitOnCaseStateNotificationGateway()
      .awaitCaseStateUpdate(input);
  }

  stopWaitingCaseStateUpdate(): void {
    this.notificationSwitcher.getWaitOnCaseStateNotificationGateway().stopWaitingCaseStateUpdate();
    return;
  }
}
